import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';

const PaymentSingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"Payment Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: "Customer",
                                key: "owner",
                                format: "ModelLink",
                            },
                            {
                                label: "Status",
                                key: "status",
                                format: "titleCase",
                            },
                            {
                                label: "Amount",
                                key: "amount",
                                format: "number"
                            },
                            {
                                label: "Product",
                                key: "order.item",
                                format: "ModelLink"
                            },
                            {
                                label: "Description",
                                key: "order.item.description"
                            },

                        ]}
                        columnB={[
                            {
                                label: "Gateway Transaction ID",
                                key: "bill.id",
                            },
                            {
                                label: "Gateway Transaction Status",
                                key: "bill.state",
                                format: "titleCase"
                            },
                            {
                                label: "Payment Gateway",
                                key: "gateway",
                                format: "titleCase"
                            },
                            {
                                label: "Amount Paid",
                                key: "amountPaid",
                                format: "number"
                            },
                            {
                                label: "Date Paid",
                                key: "datePaid",
                                format: "dateTime"
                            },
                        ]}
                        columnC={[
                            {
                                label: "Host",
                                key: "host",
                                format: "modelLink",
                            },
                            {
                                label: "Order #",
                                key: "order",
                                format: "ModelLink"
                            },
                        ]}
                    />

                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default PaymentSingleView;
